import { ThunkType } from "../../../../core/store/reducers";
import getSecurityEarningsEstimateApi from "../api/getSecurityEarningsEstimate";
import { setDisplayedEarningsEstimate } from "../statisticsDataSlice";
import { EarningsEstemateItem } from "../types";

// Load funkcija (reset + fetch)
export const loadSecurityEarningsEstimate = (
	symbol: string
): ThunkType => async (dispatch, getStore) => {
	// reset prethodnih podataka
	dispatch(setDisplayedEarningsEstimate(undefined));

	console.log(symbol)
	const statistics = await dispatch(
		getSecurity_EarningsEstimate(symbol)
	);
	console.log(statistics)

	dispatch(setDisplayedEarningsEstimate(statistics));
};

export const getSecurity_EarningsEstimate = (
	symbol: string
): ThunkType<Promise<EarningsEstemateItem | undefined>> =>
	async (dispatch, getStore, _extra) => {

		const store = getStore();

		if (store.data.auth.current.status !== "successful") {
			return undefined;
		}

		const { userId } = store.data.auth.current.user;

		const response = await dispatch(
			getSecurityEarningsEstimateApi(userId, symbol, "earnings_estimate")
		);

		console.log(response)
		if (!response || !response.meta) {
			return undefined;
		}
		const latest = response?.earnings_estimate?.[0];

		return {
			symbol: response.meta.symbol,
			date: latest.date,
			period: latest.period,
			number_of_analysts: latest.number_of_analysts,
			avg_estimate: latest.avg_estimate,
			low_estimate: latest.low_estimate,
			high_estimate: latest.high_estimate,
			year_ago_eps: latest.year_ago_eps,
		};
	};



